import * as React from 'react';
import { ThemeContext } from 'styled-components';

import { SVGIcon } from '../../../Icon';
import Box from '../../Layout/Box';

import HeaderDrawer from './Drawer/HeaderDrawer';
import { IHeaderDropdownCommon } from './common';
import { HeaderDropdownButton, HeaderDropdownListItem, HeaderDropdownWrapper } from './HeaderDropdownStyles';

const DROP_DOWN_ID = 'header-dropdown';

interface IHeaderDropdown extends IHeaderDropdownCommon {
  asListItem?: boolean;
  buttonText: string;
  onClick (): void;
}

export const HeaderDropdown: React.FC<IHeaderDropdown> = ({
  onClick,
  asListItem = true,
  buttonText,
  isOpen,
  closeDrawer,
  children
}) => {
  const ListItemWrap: React.ElementType = asListItem ? HeaderDropdownListItem : HeaderDropdownWrapper;
  const { themeTwo: { layout: { header: { dropdown }}}} = React.useContext(ThemeContext);
  const HamburgerWrapper = Box;
  const ButtonTextWrapper = Box;

  const buttonWrapperTheme = {
    display: dropdown.icon.mobile ? { base: 'none', small: 'inline-flex' } : 'inline-flex',
  };

  return (
    <ListItemWrap>
      <HeaderDropdownButton
        onClick={onClick}
        isOpen={isOpen}
        aria-label={!isOpen ? 'open menu' : 'close menu'}
        aria-controls={DROP_DOWN_ID}
        aria-expanded={isOpen}
      >
        <ButtonTextWrapper {...buttonWrapperTheme}>
          <span>{buttonText}</span>
          <SVGIcon
            color={dropdown.icon.desktop.color}
            size={dropdown.icon.desktop.size}
            icon={dropdown.icon.desktop.type}
            rotate={isOpen ? '180' : undefined}
          />
        </ButtonTextWrapper>

        {dropdown.icon.mobile && (
          <HamburgerWrapper display={{ base: 'block', small: 'none' }} alignSelf='center' padding='triple'>
            {!isOpen ? (
              <SVGIcon
                color={dropdown.icon.mobile.open.color}
                size={dropdown.icon.mobile.open.size}
                icon={dropdown.icon.mobile.open.type}
              />
            ) : (
              <SVGIcon
                color={dropdown.icon.mobile.close.color}
                size={dropdown.icon.mobile.close.size}
                icon={dropdown.icon.mobile.close.type}
              />
            )}
          </HamburgerWrapper>
        )}
      </HeaderDropdownButton>
      <HeaderDrawer isOpen={isOpen} closeDrawer={closeDrawer} id={DROP_DOWN_ID}>
        {children}
      </HeaderDrawer>
    </ListItemWrap>
  );
};

export default HeaderDropdown;
